var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer2"},[_c('div',{staticClass:"footer2btn"},[_vm._v(" 预估费用"+_vm._s(_vm.price)+" "),_c('van-button',{staticClass:"footerbtn",attrs:{"loading":_vm.loading,"loading-text":"下单中...","type":"danger"},on:{"click":_vm.subOrder}},[_vm._v("下单")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }